export default "__VITE_ASSET__Cx32Cc1O__"